import { useQuery } from 'react-query';

import { getV2ApiCompanyIdWalletFundTransfersFundTransferIdStatus } from 'src/client/spendesk-api';

export const useFundTransferStatusRefetched = (
  shouldRefresh: boolean,
  fundTransferId: string | null,
  companyId: string,
) => {
  return useQuery(
    ['fundTransferStatus', fundTransferId ?? ''],
    async () => {
      const response =
        await getV2ApiCompanyIdWalletFundTransfersFundTransferIdStatus({
          path: { companyId, fundTransferId: fundTransferId ?? '' },
        });
      if (response.statusCode === 200) {
        return response.body.data;
      }
      throw new Error('Failed to fetch fund transfer status');
    },
    {
      enabled: Boolean(fundTransferId),
      refetchInterval: shouldRefresh ? 1000 : false,
    },
  );
};
